module.exports = __webpack_public_path__ + "img/logo.mk7.opaque.fad3329f.png";